import React from 'react'
import PropTypes from 'prop-types'
import * as styles from './styles'

const defaultInvoiceData = [
  { invoice_id: 'INV-2024-001', vendor: 'Office Supplies Ltd', amount: '$1,247.50', prediction: 'approved', confidence: 0.95 },
  { invoice_id: 'INV-2024-002', vendor: 'Marketing Services Co', amount: '$3,850.00', prediction: 'fraud', confidence: 0.87 },
  { invoice_id: 'INV-2024-003', vendor: 'IT Equipment Inc', amount: '$2,199.99', prediction: 'approved', confidence: 0.92 },
  { invoice_id: 'INV-2024-004', vendor: 'Unknown Vendor LLC', amount: '$15,000.00', prediction: 'fraud', confidence: 0.94 },
  { invoice_id: 'INV-2024-005', vendor: 'Facilities Management', amount: '$875.25', prediction: 'approved', confidence: 0.98 },
  { invoice_id: 'INV-2024-006', vendor: 'Consulting Partners', amount: '$4,500.00', prediction: 'review', confidence: 0.73 }
]

const propTypes = {
  data: PropTypes.array,
  showAnimation: PropTypes.bool
}

const defaultProps = {
  data: defaultInvoiceData,
  showAnimation: false
}

const InvoiceTable = ({ data, showAnimation }) => {
  return (
    <styles.TableContainer>
      <styles.TableTitle>AI Invoice Processing Results</styles.TableTitle>
      <styles.Table>
        <styles.TableHeader>
          <styles.TableRow>
            <styles.TableHeaderCell>Invoice ID</styles.TableHeaderCell>
            <styles.TableHeaderCell>Vendor</styles.TableHeaderCell>
            <styles.TableHeaderCell>Amount</styles.TableHeaderCell>
            <styles.TableHeaderCell>AI Prediction</styles.TableHeaderCell>
            <styles.TableHeaderCell>Confidence</styles.TableHeaderCell>
          </styles.TableRow>
        </styles.TableHeader>
        <styles.TableBody>
          {data.map((invoice, index) => (
            <styles.TableRow 
              key={invoice.invoice_id}
              className={`${invoice.prediction === 'fraud' ? 'table-row--fraud' : ''} ${showAnimation ? 'animate' : ''}`}
              style={showAnimation ? { animationDelay: `${index * 150}ms` } : {}}
            >
              <styles.TableCell>{invoice.invoice_id}</styles.TableCell>
              <styles.TableCell>{invoice.vendor}</styles.TableCell>
              <styles.TableCell>{invoice.amount}</styles.TableCell>
              <styles.TableCell>
                <styles.PredictionBadge className={`prediction--${invoice.prediction}`}>
                  {invoice.prediction}
                </styles.PredictionBadge>
              </styles.TableCell>
              <styles.TableCell>
                <styles.ConfidenceBar>
                  <styles.ConfidenceFill confidence={invoice.confidence} />
                  <styles.ConfidenceText>{Math.round(invoice.confidence * 100)}%</styles.ConfidenceText>
                </styles.ConfidenceBar>
              </styles.TableCell>
            </styles.TableRow>
          ))}
        </styles.TableBody>
      </styles.Table>
      <styles.TableFooter>
        <styles.TableStats>
          <span>Processed: {data.length} invoices</span>
          <span>•</span>
          <span>Fraud detected: {data.filter(i => i.prediction === 'fraud').length}</span>
          <span>•</span>
          <span>Average confidence: {Math.round(data.reduce((acc, i) => acc + i.confidence, 0) / data.length * 100)}%</span>
        </styles.TableStats>
      </styles.TableFooter>
    </styles.TableContainer>
  )
}

InvoiceTable.propTypes = propTypes
InvoiceTable.defaultProps = defaultProps

export default InvoiceTable